"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventTypes;
(function (EventTypes) {
    EventTypes["POPUP_CLOSED"] = "POPUP_CLOSED";
    EventTypes["POPUP_FINISHED"] = "POPUP_FINISHED";
    EventTypes["POPUP_MOUNTED"] = "POPUP_MOUNTED";
    EventTypes["SEND_DATA"] = "SEND_DATA";
    EventTypes["SEND_TRANSACTION_DATA"] = "SEND_TRANSACTION_DATA";
    EventTypes["SIGNER_FINISHED"] = "SIGNER_FINISHED";
    EventTypes["TRANSACTION_EXECUTED"] = "TRANSACTION_EXECUTED";
    EventTypes["TRANSACTION_SIGNED"] = "TRANSACTION_SIGNED";
    EventTypes["CHECK_AUTHENTICATED"] = "CHECK_AUTHENTICATED";
    EventTypes["AUTHENTICATE"] = "AUTHENTICATE";
    EventTypes["LOGOUT"] = "LOGOUT";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
//# sourceMappingURL=EventTypes.js.map